import { motion } from "framer-motion";
import styled, { keyframes } from "styled-components";

export const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem;
  height: 100%;
`;

export const PageHeader = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

export const PageTitle = styled.h1`
  color: #ff6b35;
  font-size: 3rem;
  margin-bottom: 1rem;
  font-weight: bold;
  background: linear-gradient(135deg, #ff6b35, #ff8c42);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`;

export const CartLayout = styled.div`
  display: grid;
  grid-template-columns: 2fr 1.5fr;
  gap: 3rem;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

export const CartSection = styled.div`
  background: #1a1a1a;
  border-radius: 15px;
  padding: 2rem;
  border: 1px solid #333;
`;

export const SectionTitle = styled.h2`
  color: #ff6b35;
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const CartItem = styled(motion.div)`
  background: #2c2c2c;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1rem;
  border: 1px solid #444;
  display: grid;
  grid-template-columns: 80px 1fr auto auto;
  gap: 1rem;
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    text-align: center;
    gap: 0.8rem;
  }
`;

export const ItemImage = styled.div`
  width: 80px;
  height: 80px;
  background: linear-gradient(45deg, #333, #555, #ff6b35);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-weight: bold;
  font-size: 0.8rem;

  @media (max-width: 768px) {
    width: 60px;
    height: 60px;
    margin: 0 auto;
  }
`;

export const ItemInfo = styled.div`
  width: fit-content;
`;

export const ItemName = styled.h3`
  color: #ffffff;
  font-size: 1.1rem;
  margin-bottom: 0.3rem;
  font-family: "Poppins-Bold";
`;

export const ItemBand = styled.span`
  background: #ff6b35;
  color: #ffffff;
  padding: 0.2rem 0.6rem;
  border-radius: 12px;
  font-size: 0.7rem;
  font-family: "Poppins-Bold";

  margin-bottom: 0.3rem;
  display: inline-block;
`;

export const ItemSize = styled.span`
  color: #cccccc;
  font-size: 0.9rem;
  font-family: "Poppins-Regular";
`;

export const QuantityControl = styled.div`
  display: flex;
  align-items: center;
  background: #1a1a1a;
  border-radius: 8px;
  border: 1px solid #333;
  max-height: 2rem;
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const QuantityBtn = styled.button`
  background: transparent;
  color: #ffffff;
  border: none;
  padding: 0.5rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #ff6b35;
  }

  &:disabled {
    color: #666;
    cursor: not-allowed;
  }
`;

export const QuantityInput = styled.input`
  background: transparent;
  color: #ffffff;
  border: none;
  padding: 0.5rem;
  width: 50px;
  text-align: center;
  font-weight: bold;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  @media (max-width: 768px) {
    text-align: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;
export const ItemPrice = styled.div`
  text-align: right;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const CurrentPrice = styled.div`
  color: #ff6b35;
  font-size: 1.2rem;
  font-weight: bold;
`;

export const TotalPrice = styled.div`
  color: #ffffff;
  font-size: 0.9rem;
  margin-top: 0.2rem;
`;

export const RemoveBtn = styled.button`
  background: transparent;
  color: #e74c3c;
  border: 2px solid #e74c3c;
  padding: 0.5rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #e74c3c;
    color: #ffffff;
  }

  @media (max-width: 768px) {
    margin: 0 auto;
  }
`;

export const EmptyCart = styled.div`
  text-align: center;
  padding: 3rem 1rem;
  color: #cccccc;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h3 {
    color: #ff6b35;
    margin-bottom: 1rem;
    font-size: 1.5rem;
  }
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin-top: 2rem;
`;

export const PageBtn = styled.button`
  background: ${({ $active }) => ($active ? "#ff6b35" : "#2c2c2c")};
  color: #ffffff;
  border: 1px solid ${({ $active }) => ($active ? "#ff6b35" : "#333")};
  padding: 0.5rem 0.8rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s ease;

  &:hover {
    background: #ff6b35;
    border-color: #ff6b35;
  }

  &:disabled {
    background: #333;
    color: #666;
    cursor: not-allowed;
    border-color: #333;
  }
`;

export const CheckoutSection = styled.div`
  background: #1a1a1a;
  border-radius: 15px;
  padding: 2rem;
  border: 1px solid #333;
  height: fit-content;
  position: sticky;
  top: 120px;
`;

export const OrderSummary = styled.div`
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: #2c2c2c;
  border-radius: 12px;
  border: 1px solid #444;
`;

export const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.8rem;
  color: #cccccc;

  &.total {
    color: #ffffff;
    font-weight: bold;
    font-size: 1.1rem;
    border-top: 1px solid #444;
    padding-top: 0.8rem;
    margin-top: 1rem;
    margin-bottom: 0;
  }

  .label {
    font-weight: ${({ $bold }) => ($bold ? "bold" : "normal")};
  }

  .value {
    color: ${({ $highlight }) => ($highlight ? "#ff6b35" : "inherit")};
    font-weight: bold;
  }
`;

export const CheckoutForm = styled.form`
  margin-top: 2rem;
`;

export const FormSection = styled.div`
  margin-bottom: 2rem;
`;

export const FormSectionTitle = styled.h4`
  color: #ff6b35;
  font-size: 1.1rem;
  margin-bottom: 1rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: ${({ $columns }) => $columns || "1fr 1fr"};
  gap: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 1rem;
  grid-column: ${({ $span }) => $span || "auto"};
`;

export const FormLabel = styled.label`
  display: block;
  color: #ffffff;
  font-weight: bold;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
`;

export const FormInput = styled.input`
  width: 100%;
  background: #2c2c2c;
  border: 1px solid #444;
  border-radius: 8px;
  padding: 0.8rem;
  color: #ffffff;
  font-size: 0.9rem;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: #ff6b35;
  }

  &::placeholder {
    color: #666;
  }

  &.error {
    border-color: #e74c3c;
  }
`;

export const FormTextarea = styled.textarea`
  width: 100%;
  background: #2c2c2c;
  border: 1px solid #444;
  border-radius: 8px;
  padding: 0.8rem;
  color: #ffffff;
  font-size: 0.9rem;
  min-height: 80px;
  resize: vertical;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: #ff6b35;
  }

  &::placeholder {
    color: #666;
  }
`;

export const ErrorMessage = styled.div`
  color: #e74c3c;
  font-size: 0.8rem;
  margin-top: 0.3rem;
  display: flex;
  align-items: center;
  gap: 0.3rem;
`;

// export const SubmitButton = styled.button`
//   width: 100%;
//   background: #ff6b35;
//   color: #ffffff;
//   border: none;
//   border-radius: 12px;
//   padding: 1rem;
//   font-size: 1rem;
//   font-weight: bold;
//   cursor: pointer;
//   transition: all 0.3s ease;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   gap: 0.5rem;

//   &:hover {
//     background: #e55a2b;
//     transform: translateY(-2px);
//   }

//   &:disabled {
//     background: #666;
//     cursor: not-allowed;
//     transform: none;
//   }
// `;

export const ShippingOptions = styled.div`
  margin-bottom: 1.5rem;
`;

export const ShippingOption = styled.div`
  background: #2c2c2c;
  border: 1px solid ${({ $selected }) => ($selected ? "#ff6b35" : "#444")};
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    border-color: #ff6b35;
  }
`;

export const ShippingInfo = styled.div`
  .name {
    color: #ffffff;
    font-weight: bold;
    margin-bottom: 0.2rem;
  }
  .desc {
    color: #cccccc;
    font-size: 0.8rem;
  }
`;

export const ShippingPrice = styled.div`
  color: #ff6b35;
  font-weight: bold;
`;

const fadeSlideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const checkmarkDraw = keyframes`
  0% {
    stroke-dashoffset: 20px;
  }
  100% {
    stroke-dashoffset: -2px;
  }
`;

const spinLoader = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  background: linear-gradient(135deg, #ff6b35 0%, #e55a2b 100%);
  color: #ffffff;
  border: none;
  border-radius: 12px;
  padding: 1rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  overflow: hidden;

  /* Smooth transitions */
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);

  /* Početni shadow */
  box-shadow: 0 4px 12px rgba(255, 107, 53, 0.25),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);

  /* Ikona transition */
  svg {
    transition: transform 0.2s ease;
  }

  /* HOVER EFFECTS */
  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(255, 107, 53, 0.35),
      inset 0 1px 0 rgba(255, 255, 255, 0.2);
    background: linear-gradient(135deg, #e55a2b 0%, #ff6b35 100%);

    svg {
      transform: scale(1.1);
    }
  }

  /* ACTIVE/CLICK */
  &:active:not(:disabled) {
    transform: translateY(0);
    transition-duration: 0.1s;
    box-shadow: 0 2px 8px rgba(255, 107, 53, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.1);
  }

  /* LOADING STATE */
  &.loading {
    background: linear-gradient(135deg, #444 0%, #696969 100%);
    cursor: not-allowed;
    pointer-events: none;

    svg {
      animation: ${spinLoader} 1s linear infinite;
    }

    &:hover {
      transform: none;
      box-shadow: 0 4px 12px rgba(68, 68, 68, 0.25);
    }
  }

  /* SUCCESS STATE */
  &.success {
    background: linear-gradient(135deg, #27ae60 0%, #2ecc71 100%);
    animation: ${fadeSlideIn} 0.4s ease-out;

    svg {
      stroke-dasharray: 20px;
      stroke-dashoffset: 10px;
      animation: ${checkmarkDraw} 0.5s ease-out 0.2s forwards;
    }

    &:hover {
      background: linear-gradient(135deg, #229954 0%, #27ae60 100%);
      box-shadow: 0 8px 25px rgba(39, 174, 96, 0.35),
        inset 0 1px 0 rgba(255, 255, 255, 0.2);
    }
  }

  /* DISABLED STATE */
  &:disabled {
    background: linear-gradient(135deg, #444 0%, #696969 100%);
    cursor: not-allowed;

    &:hover {
      transform: none;
      box-shadow: 0 4px 12px rgba(68, 68, 68, 0.25);
    }
  }

  /* FOCUS */
  &:focus-visible {
    outline: none;
    box-shadow: 0 4px 12px rgba(255, 107, 53, 0.25),
      0 0 0 3px rgba(255, 107, 53, 0.3);
  }

  /* Text transitions */
  span {
    transition: all 0.2s ease;
  }

  @media (max-width: 768px) {
    padding: 0.875rem 1.25rem;
    font-size: 0.9rem;

    &:hover:not(:disabled) {
      transform: translateY(-1px);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    transition: background 0.2s ease, box-shadow 0.2s ease;

    &:hover:not(:disabled) {
      transform: none;
    }

    &:active:not(:disabled) {
      transform: none;
    }

    svg {
      animation: none !important;
    }

    &.success {
      animation: none;
    }
  }
`;
